import { render, staticRenderFns } from "./menu-sub.vue?vue&type=template&id=edc08888&scoped=true&"
import script from "./menu-sub.vue?vue&type=script&lang=js&"
export * from "./menu-sub.vue?vue&type=script&lang=js&"
import style0 from "./menu-sub.vue?vue&type=style&index=0&id=edc08888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc08888",
  null
  
)

export default component.exports